import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=135aa773&scoped=true"
import script from "./Course.js?vue&type=script&lang=js&external"
export * from "./Course.js?vue&type=script&lang=js&external"
import style0 from "./Course.scss?vue&type=style&index=0&id=135aa773&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135aa773",
  null
  
)

export default component.exports